
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { useNavigate } from "react-router-dom";
import { deleteClient } from "@/services/client/clientDeleteService";

export function useClientDelete() {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleDeleteClient = async (clientId: string) => {
    if (!clientId) return;
    
    setIsDeleting(true);
    setError(null);
    
    try {
      await deleteClient(clientId);
      
      toast({
        title: "Success",
        description: "Client deleted successfully",
      });
      
      // Navigate back to clients list
      navigate('/clients');
    } catch (error: any) {
      console.error("Error in handleDeleteClient:", error);
      
      // Set error message for the dialog
      setError(error.message || "An unexpected error occurred");
      
      toast({
        title: "Error",
        description: error.message || "An unexpected error occurred",
        variant: "destructive",
      });
      
      return false;
    } finally {
      setIsDeleting(false);
    }
    
    return true;
  };

  return {
    isDeleting,
    error,
    deleteClient: handleDeleteClient
  };
}
